export default __webpack_public_path__ + "static/media/WAS0333.34I-41686_-24974_0.087ad61e.jpg";